const models = {
  "user": {
    basics: {
      name: String,
      email: String,
      image: String,
      title: String,
      bio: String
    },
    items: {
      "[itemType]": {
        arrayMap: "Array of item IDs (String)",
        example: ["itemId1", "itemId2"]
      }
    },
    cart: {
      "[itemId]": {
        arrayMap: "Array format: [type, id, purchases, qty, seller, title]",
        example: ["product", "prod123", {cost: 10}, 2, "userId", "Item Title"]
      }
    },
    msgs: {
      "[messageId]": String
    },
    notifications: {
      "[notificationId]": Boolean
    },
    sales: {
      "[orderId]": {
        arrayMap: "Array of order items for this sale",
        example: [{type: "product", iitemid: "id", qty: 1}]
      }
    },
    orders: {
      arrayMap: "Array of order IDs (String)",
      example: ["orderId1", "orderId2"]
    },
    userreps: {
      "[itemId]": String
    },
    auctions: {
      "[type_id]": Number
    },
    files: {
      "[fileId]": {
        name: String,
        url: String,
        size: Number,
        type: String,
        timestamp: Number,
        hash: String
      }
    },
    keys: {
      "[keyId]": {
        key: String,
        created: Number,
        type: String
      }
    },
    uid: String,
    email: String
  },
  "page": {
    text: String,
    styles: {
      classes: String,
      style: {
        "[cssProperty]": String,
        example: {
          color: "#000",
          backgroundColor: "#fff",
          padding: "10px"
        }
      }
    },
    components: {
      arrayMap: "Array of component names (String) to render on this page",
      example: ["navigation", "footer", "content"]
    },
    pages: {
      arrayMap: "Array of sub-page names (String)",
      example: ["subpage1", "subpage2"]
    },
    published: Boolean,
    menu: Boolean,
    automenu: Boolean,
    media: {
      "[mediaType]": {
        "[mediaName]": String
      }
    },
    permissions: {
      "[roleId]": Boolean
    },
    routes: {
      "[routeName]": {
        path: String,
        component: String,
        meta: {},
        query: {}
      }
    }
  },
  "item": {
    created: Number,
    basics: {
      title: String,
      description: String,
      image: String,
      tags: {
        arrayMap: "Array of tag strings",
        example: ["tag1", "tag2", "category"]
      }
    },
    purchases: {
      cost: Number,
      currency: String,
      "shipping and handling": Number,
      auction: Boolean,
      "auction end": String,
      "auction complete": Boolean,
      "minimum bid": Number
    },
    bids: {
      "[bidAmount]": String
    },
    social: {
      likes: Number,
      shares: Number,
      comments: Number
    },
    media: {
      "[mediaId]": {
        url: String,
        type: String,
        caption: String
      }
    },
    user: String,
    type: String,
    hash: String,
    id: String,
    ownedBy: String,
    events: {
      "start-date": String,
      "end-date": String,
      location: String
    },
    jobs: {
      "job-title": String,
      "job-type": String,
      pay: Number,
      "pay-currency": String,
      "pay-schedule": String,
      seasonal: Boolean
    },
    forms: {
      arrayMap: "Array of form objects with name, description, inputs",
      example: [{name: "basics", inputs: {}}]
    }
  },
  "comment": {
    id: String,
    text: String,
    type: String,
    user: String,
    timestamp: Number,
    ownedBy: String,
    media: {
      arrayMap: "Array of media URLs (String)",
      example: ["https://example.com/image.jpg"]
    },
    components: {
      arrayMap: "Array of component configurations",
      example: []
    },
    links: {
      arrayMap: "Array of link URLs",
      example: ["https://example.com"]
    },
    embeds: String,
    published: Boolean
  },
  "message": {
    id: String,
    topic: String,
    users: {
      arrayMap: "Array of user IDs (String) participating in this message thread",
      example: ["userId1", "userId2"]
    },
    type: String,
    banter: {
      "[timestamp]": {
        text: String,
        user: String
      }
    },
    owner: String
  },
  "conversation": {
    id: String,
    topic: String,
    users: {
      arrayMap: "Array of user IDs (String) participating in this conversation",
      example: ["userId1", "userId2"]
    },
    type: String,
    banter: {
      "[timestamp]": {
        text: String,
        user: String
      }
    },
    owner: String
  },
  "function": {
    name: String,
    description: String,
    inputs: {
      "[inputName]": {
        type: String,
        required: Boolean,
        default: String,
        static: String
      }
    },
    commands: {
      arrayMap: "Array of command objects to execute in sequence",
      example: [{action: "api", type: null, payload: {}, method: "get"}]
    },
    output: {
      "[outputName]": String
    },
    test: {
      arrayMap: "Array of test inputs and expected return values",
      example: ["inputs", "return value"]
    },
    show: {
      "[key]": Boolean
    },
    state: {
      outputs: []
    }
  },
  "hook": {
    fun: String,
    payload: {
      "[key]": String
    },
    if: {
      arrayMap: "Array of condition objects for conditional execution",
      example: [{comparator: "===", conditions: []}]
    },
    from: String,
    getpayload: {
      "[key]": String
    },
    get: {
      name: String,
      inputs: {
        "[inputName]": String
      }
    }
  },
  "app": {
    basics: {
      database: String,
      "app name": String,
      items: {
        arrayMap: "Array of item type definitions with forms, abilities, views",
        example: [{
          name: "event",
          type: "asset",
          forms: [],
          abilities: {comments: false, reputation: false},
          views: {list: true, item: true, create: true}
        }]
      },
      modules: {
        arrayMap: "Array of enabled module names (String): AUTH, BLOCKCHAIN, EVENTS, JOBS, MAPS, MESSAGES, CART, PROFILES, COMMENTS, REPUTATION, SECRETS, NOTIFICATIONS, COURSES",
        example: ["AUTH", "MESSAGES", "PROFILES"]
      },
      api: {
        arrayMap: "Array of API endpoint configurations",
        example: []
      },
      logo: String,
      meta: String,
      live: Boolean,
      preview: String
    },
    style: {
      "background-color": String,
      color: String,
      navbar: String,
      container: String,
      "sub-container": String,
      button: String,
      success: String,
      warn: String,
      update: String,
      indicate: String,
      "background-image": String,
      "custom-css": String
    },
    pages: {
      "[pageName]": {
        text: String,
        styles: {},
        components: Array,
        pages: Array,
        published: Boolean,
        media: {},
        permissions: {},
        routes: {}
      }
    },
    users: {
      arrayMap: "Array of user IDs (String) with app access",
      example: ["userId1", "userId2"]
    },
    owner: String,
    version: Number,
    advanced: {
      functions: {
        "[functionName]": {
          name: String,
          description: String,
          inputs: {},
          commands: Array,
          output: {},
          test: Array,
          show: {},
          state: {}
        }
      },
      hooks: {
        app: {
          beforeLoad: {
            arrayMap: "Array of function names (String) to execute before app loads",
            example: ["initFunction", "loadData"]
          },
          afterLoad: {
            arrayMap: "Array of function names (String) to execute after app loads",
            example: ["trackPageView"]
          }
        },
        profile: {
          "[hookName]": {
            fun: String,
            payload: {},
            if: Array
          }
        },
        dashboard: {
          "[hookName]": {
            fun: String,
            payload: {},
            if: Array
          }
        },
        login: {
          "[hookName]": {
            fun: String,
            payload: {},
            if: Array
          }
        },
        transaction: {
          "[hookName]": {
            fun: String,
            payload: {},
            if: Array
          }
        }
      },
      roles: {
        "[roleName]": {
          members: Array,
          signupRequirements: {},
          hooks: {},
          permissions: {},
          requirements: {}
        }
      }
    },
    itemTypes: {
      arrayMap: "Array of item type names (String) - derived from basics.items during init",
      example: ["event", "product", "service"]
    }
  },
  "form": {
    name: String,
    description: String,
    inputs: {
      arrayMap: "Array of input field configurations",
      example: [{
        inputType: "input",
        label: "title",
        type: "text",
        placeholder: "Enter title",
        default: "",
        priority: 1,
        if: []
      }]
    }
  },
  "notification": {
    id: String,
    actions: {
      arrayMap: "Array of action strings/buttons for this notification",
      example: ["view", "dismiss", "reply"]
    },
    subMessage: String,
    from: String,
    link: String,
    message: String,
    to: {
      arrayMap: "Array of user IDs (String) to receive this notification",
      example: ["userId1", "userId2"]
    },
    type: String,
    timestamp: Number
  },
  "order": {
    id: String,
    complete: Boolean,
    paid: Boolean,
    shipping: {
      address: String,
      city: String,
      state: String,
      zip: String,
      country: String,
      name: String,
      phone: String
    },
    items: {
      arrayMap: "Array of order item objects",
      example: [{
        type: "product",
        iitemid: "prod123",
        purchase: {cost: 10, currency: "USD"},
        qty: 2,
        seller: "userId",
        itemTitle: "Product Name",
        status: "new-order",
        shipping: {},
        orderId: "order123",
        buyer: "buyerId",
        timestamp: 1234567890
      }]
    },
    total: Number,
    timestamp: Number
  },
  "cartItem": {
    "[itemId]": {
      arrayMap: "Array format: [type, id, purchases, qty, seller, title]",
      example: ["product", "prod123", {cost: 10, currency: "USD"}, 2, "sellerId", "Item Title"]
    }
  },
  "reputation": {
    ref: String,
    feedback: {
      content: String,
      quality: Number,
      data: {
        "[key]": String
      }
    },
    user: String,
    timestamp: Number,
    type: String,
    rId: String,
    rType: String
  },
  "orderItem": {
    type: String,
    iitemid: String,
    purchase: {
      cost: Number,
      currency: String,
      "shipping and handling": Number
    },
    qty: Number,
    seller: String,
    itemTitle: String,
    status: String,
    shipping: {
      address: String,
      city: String,
      state: String,
      zip: String,
      country: String,
      name: String,
      phone: String
    },
    orderId: String,
    buyer: String,
    timestamp: Number
  },
  "role": {
    members: {
      arrayMap: "Array of user IDs (String) assigned to this role",
      example: ["userId1", "userId2"]
    },
    signupRequirements: {
      "[fieldName]": {
        required: Boolean,
        type: String,
        validation: String
      }
    },
    hooks: {
      "[hookName]": {
        fun: String,
        payload: {
          "[key]": String
        }
      }
    },
    permissions: {
      "[resourceType]": {
        create: Boolean,
        read: Boolean,
        update: Boolean,
        delete: Boolean
      }
    },
    requirements: {
      "[fieldName]": {
        required: Boolean,
        type: String,
        validation: String
      }
    }
  },
  "value": {
    datatype: String,
    key: String,
    value: String
  },
  "transaction": {
    from: String,
    to: String,
    amount: Number,
    fee: Number,
    sign: String,
    timestamp: Number,
    type: String,
    status: String
  },
  "token": {
    name: String,
    artist: String,
    supply: Number,
    collection: String,
    contract_id: String,
    creator: String,
    discord: String,
    rarity: String,
    set: String,
    twitter: String,
    copyright: String,
    ticker: String,
    metadata: {
      name: String,
      description: String,
      image: String,
      attributes: {
        arrayMap: "Array of NFT attribute objects",
        example: [{trait_type: "Background", value: "Blue"}]
      },
      files: {
        arrayMap: "Array of file objects associated with this token",
        example: [{name: "image.png", url: "https://...", type: "image/png"}]
      }
    }
  },
  "wallet": {
    address: String,
    private: String,
    public: String,
    chain: String,
    password: String,
    nmonic: String,
    keyPair: {
      __D: String,
      __Q: String,
      publicKey: String,
      network: String
    }
  },
  "aiAgent": {
    prompt: String,
    response: {
      text: String,
      data: {
        "[key]": String
      },
      error: String
    },
    context: {
      arrayMap: "Array of context strings or objects for AI agent",
      example: ["previous message", "system context"]
    },
    model: String,
    functions: {
      arrayMap: "Array of function names (String) available to AI agent",
      example: ["create", "query", "update"]
    }
  },
  "aiTask": {
    status: String,
    metadata: {
      startTime: Number,
      endTime: Number,
      duration: Number,
      attempts: Number
    },
    context: {
      input: {
        "[key]": String
      },
      output: {
        "[key]": String
      },
      state: {
        "[key]": String
      }
    },
    taskId: String,
    messageConversationId: String
  },
  "terminal": {
    currentMessage: String,
    currentConversationId: String,
    selectedModel: String,
    availableModels: {
      arrayMap: "Array of available AI model names (String)",
      example: ["llama3.2:latest", "gpt-4", "claude-3"]
    },
    selectedPrompt: String,
    showState: Boolean,
    lastPlan: {
      steps: {
        arrayMap: "Array of step objects describing the plan",
        example: [{step: 1, action: "query", description: "Fetch data"}]
      },
      description: String,
      estimated: Number
    },
    currentExecution: {
      step: Number,
      status: String,
      progress: Number
    },
    lastResult: {
      success: Boolean,
      data: {
        "[key]": String
      },
      error: String
    },
    validationError: String,
    executionError: String,
    context: {
      functions: {
        arrayMap: "Array of function names available in context",
        example: ["create", "update", "query"]
      },
      statePaths: {
        arrayMap: "Array of state paths (String) relevant to current context",
        example: ["app.basics", "user.items"]
      },
      text: {
        arrayMap: "Array of text context strings",
        example: ["user message", "system response"]
      }
    },
    previewMode: String,
    previewComponent: {
      name: String,
      props: {
        "[propName]": String
      },
      rendered: String
    }
  },
  "command": {
    action: String,
    type: String,
    payload: {
      "[key]": String
    },
    method: String,
    inputs: {
      "[inputName]": String
    },
    tests: {
      arrayMap: "Array of test cases for this command",
      example: []
    }
  },
  "relate": {
    type: String,
    itemType: String,
    id: String,
    status: String,
    secret: Boolean
  },
  "index": {
    "[key]": {
      value: String,
      type: String,
      ref: String,
      score: Number
    }
  },
  "ref": {
    image: {
      "[userId]": String
    },
    name: {
      "[userId]": String
    },
    title: {
      "[itemId]": String
    }
  },
  "device": {
    language: String,
    mobile: Boolean,
    online: Boolean,
    platform: String,
    product: String,
    userAgent: String,
    vendor: String
  },
  "api": {
    actions: {
      arrayMap: "Array of action definition objects",
      example: [{name: "detecttype", description: "Returns type of data", returntype: String}]
    },
    mutations: {
      "[mutationName]": {
        description: String,
        payload: {
          "[key]": String
        }
      }
    }
  },
  "counts": {
    buy: Number,
    cart: Number,
    cheating: {
      "[countType]": Number
    },
    componentKey: Number,
    edit: Number,
    messages: Number,
    notifications: Number,
    ordersIter: Number,
    jobs: Number,
    events: Number,
    reviews: Number,
    salesIter: Number,
    auctions: Number
  },
  "show": {
    "[key]": Boolean
  },
  "schedule": {
    command: String,
    time: Number,
    payload: {
      action: String,
      data: {
        "[key]": String
      },
      callback: String
    }
  },
  "secrets": {
    str: String,
    shares: Number,
    thresh: Number
  }
}

export default models;
